export default __webpack_public_path__ + "static/media/BIFI-logo.3c8ba2f1.svg";